<template>
  <!-- 因为字段禁用，点击没有反应，因此每个字段前用一个div遮罩一下，让整个字段区域作为热区-->
  <div class="item-input-content" v-if="((source == 20 && modulesItem.layoutFieldType == 20) || source == 35) && modulesItem?.fieldType != 18" @click="clickFieldModules($event)"></div>

  <!-- 多行文本 -->
  <jw-input v-if="modulesItem.fieldType == 1" :placeholder="modulesItem.placeholder" disabled v-model="modulesItem.defaultValue" class="card-form-item-value" />

  <!-- 单选按钮 -->
  <jw-radio-group class="card-form-item-value" v-else-if="modulesItem.fieldType == 2 && JSON.parse(modulesItem.fieldExt)?.length <= 3" v-model="modulesItem.defaultValue" disabled>
    <jw-radio v-for="item in JSON.parse(modulesItem.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
  </jw-radio-group>
  <!-- 多选按钮 -->
  <jw-checkbox-group class="card-form-item-value" v-else-if="modulesItem.fieldType == 3 && JSON.parse(modulesItem.fieldExt)?.length <= 3" v-model="modulesItem.defaultValue" disabled>
    <jw-checkbox v-for="item in JSON.parse(modulesItem.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-checkbox>
  </jw-checkbox-group>
  <!-- 下拉单选 -->
  <jw-select v-model="modulesItem.defaultValue" v-else-if="modulesItem.fieldType === 4 || (modulesItem?.fieldType === 2 && JSON.parse(modulesItem.fieldExt)?.length > 3)" :placeholder="modulesItem.placeholder" class="card-form-item-value" :options="JSON.parse(modulesItem.fieldExt)" disabled> </jw-select>
  <!-- 下拉多选 -->
  <jw-select v-model="modulesItem.defaultValue" v-else-if="modulesItem.fieldType === 5 || (modulesItem?.fieldType === 3 && JSON.parse(modulesItem.fieldExt)?.length > 3)" :placeholder="modulesItem.placeholder" :max-tag-count="3" multiple class="card-form-item-value" :options="tools.isJSON(modulesItem?.fieldExt) ? JSON.parse(modulesItem.fieldExt) : modulesItem.fieldExt?.length > 0 ? modulesItem.fieldExt : ''" disabled> </jw-select>

  <!--(人员) 部门-->
  <jw-input v-else-if="modulesItem.fieldType === 6 || modulesItem.fieldType === 22" :placeholder="modulesItem.placeholder" class="card-form-item-value" v-model="modulesItem.fv" disabled />

  <!-- 数字 -->
  <template v-else-if="modulesItem.fieldType === 7">
    <jw-input-number v-if="JSON.parse(modulesItem.fieldExt)?.numberUnit" v-model="modulesItem.defaultValue" class="card-form-item-value" :placeholder="modulesItem.placeholder" :precision="Number(JSON.parse(modulesItem.fieldExt)?.numberFormat)" disabled>
      <template #append> {{ JSON.parse(modulesItem.fieldExt)?.numberUnit || '' }} </template>
    </jw-input-number>
    <jw-input-number v-else v-model="modulesItem.defaultValue" class="card-form-item-value" :placeholder="modulesItem.placeholder" :precision="Number(JSON.parse(modulesItem.fieldExt)?.numberFormat)" disabled />
  </template>
  <!-- 日期格式 -->
  <jw-date-picker v-else-if="modulesItem.fieldType === 8" :show-time="modulesItem.fieldExt?.indexOf('HH') > -1" v-model="modulesItem.defaultValue" :placeholder="modulesItem.placeholder" class="card-form-item-value" :format="modulesItem.fieldExt" position="br" disabled />
  <!-- 日期范围 -->
  <template v-else-if="modulesItem.fieldType === 9">
    <jw-range-picker v-model="modulesItem.defaultValue" class="card-form-item-value" disabled />
  </template>

  <!-- 级联选择器 -->
  <jw-cascader v-else-if="modulesItem.fieldType === 10" :options="JSON.parse(modulesItem.fieldExt)" :placeholder="modulesItem.placeholder" class="card-form-item-value" path-mode v-model="modulesItem.defaultValue" disabled />
  <!-- 金额 -->
  <div v-else-if="modulesItem.fieldType === 16" class="card-form-item-value">
    <jw-input-number class="system-form-item-value" :placeholder="modulesItem.placeholder" :precision="Number(modulesItem.fieldExt)" v-model="modulesItem.defaultValue" disabled />
  </div>
  <!-- 附件 -->
  <template v-else-if="modulesItem.fieldType === 18">
    <template v-if="modulesItem.defaultValue?.length">
      <!-- 子表单 -->
      <template v-if="source == 35">
        <jw-popover :position="subIndex == 0 ? 'rt' : subIndex == props?.list?.modules?.length - 1 && props?.list?.modules?.length - 1 >= 4 ? 'lt' : 'top'" popup-container=".drag-item-content-ele">
          <jw-button style="margin-top: 5px">查看</jw-button>
          <template #content>
            <div class="attachment-list">
              <p v-for="obj in modulesItem.defaultValue" :key="obj.name">
                <jw-link :href="obj.url" target="_blank"> {{ obj.name }}</jw-link>
              </p>
            </div>
          </template>
        </jw-popover>
      </template>
      <!-- 主表数据 -->
      <div class="attachment-list" v-if="source == 20">
        <p v-for="obj in modulesItem.defaultValue" :key="obj.name">
          <jw-link :href="obj.url" target="_blank"> {{ obj.name }}</jw-link>
        </p>
      </div>
    </template>

    <template v-else>
      <!-- 因为字段禁用，点击没有反应，因此每个字段前用一个div遮罩一下，让整个字段区域作为热区-->
      <div class="item-input-content" @click="clickFieldModules($event)"></div>
      <jw-input :placeholder="modulesItem.placeholder" class="card-form-item-value" :default-value="modulesItem.defaultValue" disabled />
    </template>
  </template>
  <!-- 百分比 -->
  <div v-else-if="modulesItem.fieldType === 23" class="card-form-item-value">
    <jw-input-number class="system-form-item-value" :placeholder="modulesItem.placeholder" :precision="Number(JSON.parse(modulesItem.fieldExt)?.numberFormat)" v-model="modulesItem.defaultValue" disabled />
  </div>
  <template v-else-if="modulesItem.fieldType === 26">
    <jw-input :input-attrs="{ value: tools.handleRichText(modulesItem.defaultValue || '')?.replace('-', '') }" :placeholder="modulesItem.placeholder" class="card-form-item-value" disabled />
  </template>
  <!--(单行文本,超链接,查找关联,编码,等) -->
  <jw-input v-else :placeholder="modulesItem.placeholder" class="card-form-item-value" v-model="modulesItem.defaultValue" disabled />
</template>

<script setup>
import { tools } from '@/utils/tools';
import { ref, inject, watchEffect } from 'vue';
const props = defineProps({
  list: {
    //布局信息
    type: Object,
    default: () => {}
  },
  modules: {
    //字段信息
    type: Object,
    default: () => {}
  },

  //20:主表数据 35：子表单
  source: {
    type: Number || String,
    default: 20
  },
  parentIndex: {
    //父级的索引
    type: Number || String,
    default: ''
  },
  itemIndex: {
    //当前元素的索引
    type: Number || String,
    default: ''
  },
  subIndex: {
    //子字段的索引
    type: Number || String,
    default: ''
  }
});
const modulesItem = ref(props?.modules);
watchEffect(() => {
  modulesItem.value = props?.modules;
});
const getParentMetheds = inject('publicMethods'); //主表方法
const selectModules = getParentMetheds?.selectModules || (() => {}); //父组件方法
const getParentSubMetheds = inject('publicSubMethods'); //子表单方法
const selectSubModules = getParentSubMetheds?.selectSubModules || (() => {}); //父组件方法

const clickFieldModules = (e) => {
  //点击字段
  if (props.source == 35) {
    //子表单--子字段
    selectSubModules(e, modulesItem.value, props.subIndex);
  } else {
    //其他字段
    selectModules(modulesItem.value, props.parentIndex, props.itemIndex);
  }
};
</script>
<style scoped lang="less">
@import './field-modules.less';
</style>
